exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".audit-window {\n  width: 95vw;\n  max-width: 95vw;\n  margin-top: 3rem;\n  margin-bottom: auto; }\n  .audit-window .modal-content {\n    height: calc(100vh - 6rem); }\n", ""]);

